import {
  CopyToClipboardLabel,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@crossnokaye/ux-common';

interface CopyTokenDialogProps {
  token: string;
  isOpen: boolean;
  onClose: (open: boolean) => void;
}

export const CopyTokenDialog = ({ token, isOpen, onClose }: CopyTokenDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{'Your New Token'}</DialogTitle>
          <DialogDescription>
            {
              'Please copy your token now. Once you close this window you will not be able to see it again.'
            }
          </DialogDescription>
        </DialogHeader>

        <CopyToClipboardLabel
          className={'bg-muted p-4 rounded-md'}
          tooltip={'Copy Token'}
          value={token}
        >
          <code className={'text-sm flex-1 break-all w-48 sm:w-auto'}>{token}</code>
        </CopyToClipboardLabel>
      </DialogContent>
    </Dialog>
  );
};
